import configInit from './init'

window.AppConfig = {
  subDomain: configInit.subDomain,
  baseApiUrl: 'https://resi.genietree.biz/',
  apiUrl: 'https://resi.genietree.biz/api/v1/',
  webSocketUrl: 'wss://resi.genietree.biz/ws',
  clientId: 'rcs-web',
  clientSecret: 'cb67d4ae3',
  googleApiKey: 'AIzaSyAjf3x7e9tSqU9dMHjki76zLI1UBX4Df9E',
  fbase: {
    initializeConfig: {
      apiKey: 'AIzaSyBURxWdjw2MGY7fm3QY83P9jJmiluUBXbU',
      authDomain: 'ics-prod-222416.firebaseapp.com',
      databaseURL: 'https://ics-prod-222416.firebaseio.com',
      projectId: 'ics-prod-222416',
      storageBucket: 'ics-prod-222416.appspot.com',
      messagingSenderId: '437592383519'
    },
    vapidKey: 'BECl7ojYyzdJz7LcKHzKGZ4hk_S9mf2PJ7foiTZdysAgcLwzCDnUi9wWJ6zbSNsNvo0KelNyQ6f_ELyhSSH6JcU'
  },
  IntervalRefreshData: 120000,
  IntervalRefreshDataDashboard: 300000,
  dateFormat: 'DD-MM-YYYY, hh:mm:ss A',
  shortDateFormat: 'DD-MM-YYYY'
}



// WEBPACK FOOTER //
// ./src/config/production.js